// Ticket history: stored in localStorage. Each entry captures the ticket
// content, cost, track, race, and timestamp so the user can review after
// the card runs.

const KEY = "raceHandicap.ticketHistory.v1";
const MAX_ENTRIES = 100;
const EVENT = "raceHandicap:ticketHistoryChanged";

const notify = () => {
  try {
    window.dispatchEvent(new CustomEvent(EVENT));
  } catch {
    /* SSR / no window — ignore */
  }
};

export const onTicketHistoryChange = (fn) => {
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
};

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
};

const write = (arr) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX_ENTRIES)));
  } catch {
    /* quota exceeded — ignore */
  }
};

// De-duplicate: identical (kind + track + race + horses + base) within
// the last 2s is a no-op so a double-click on Archive doesn't spam the log.
// (Archive is manual now, so we no longer need the 60s window that guarded
// against re-render duplicates.)
const sig = (t) =>
  JSON.stringify({
    kind: t.kind,
    track: t.track || "",
    race: t.race || "",
    horses: t.horses,
    base: t.base,
  });

export const saveTicket = (ticket) => {
  const arr = read();
  const nowSig = sig(ticket);
  const recent = arr.find(
    (t) => sig(t) === nowSig && Date.now() - t.ts < 2000
  );
  if (recent) return recent;
  const entry = {
    id: `t-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    ts: Date.now(),
    ...ticket,
  };
  const next = [entry, ...arr];
  write(next);
  notify();
  return entry;
};

export const getTickets = () => read();

export const clearTickets = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  notify();
};

export const deleteTicket = (id) => {
  const arr = read().filter((t) => t.id !== id);
  write(arr);
  notify();
  return arr;
};

export const updateTicket = (id, patch) => {
  const arr = read().map((t) => (t.id === id ? { ...t, ...patch } : t));
  write(arr);
  notify();
  return arr;
};
